import React from 'react';
import { OrderingUnavailableHeaderDesktop } from './OrderingUnavailableHeaderDesktop.ui';
import { OrderingUnavailableHeaderMobile } from './OrderingUnavailableHeaderMobile.ui';
import { useScreenSizeState } from '@olo-web/client-state';

export const OrderingUnavailableHeader = () => {
  const { isMdDown } = useScreenSizeState();

  if (isMdDown) return <OrderingUnavailableHeaderMobile />;

  return <OrderingUnavailableHeaderDesktop />;
};
